/** Mirrors enums.AccidentType (api/app/enums/accident_type.go): Filevine's own
 *  MVA Case Type dropdown (TMF-556), not a firm vocabulary. */
export type AccidentType =
  | "Standard MVA"
  | "DUI MVA"
  | "Bicycle vs MVA"
  | "Pedestrian vs MVA"
  | "Motorcycle";

export const ACCIDENT_TYPES: readonly AccidentType[] = [
  "Standard MVA",
  "DUI MVA",
  "Bicycle vs MVA",
  "Pedestrian vs MVA",
  "Motorcycle",
];
